import { render, staticRenderFns } from "./s-notice.vue?vue&type=template&id=19ae3a6b&scoped=true&"
import script from "./s-notice.vue?vue&type=script&lang=js&"
export * from "./s-notice.vue?vue&type=script&lang=js&"
import style0 from "./s-notice.vue?vue&type=style&index=0&id=19ae3a6b&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19ae3a6b",
  null
  
)

export default component.exports